module.exports = {"title":"GoGoVan - 個人資料","section_profile_title":"個人資料","section_profile_photo":"頭像","section_profile_set_picture":"變更","section_profile_password":"密碼:","section_profile_password_change":"變更","section_profile_info":"基本資料","section_profile_address":"地址","section_profile_logout":"登出","section_profile_update":"儲存"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json/hk/zh_hk/setting/profile/locale.json
// module id = 630
// module chunks = 0 1 2 3 4 5